export default {
    methods: {
        navigateTo(routeName, params = {}) {
            this.$router.push({ name: routeName, params });
        },
    },
};
